import { gql } from "@apollo/client";

export const rewardFragment = gql`
  fragment RewardFields on Reward {
    id
    name
    description
    rarity
    icon
    price
    isRewarded
    rewardedOn
  }
`;